export class DataUtil {

  public static readonly MESES = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

  public static readonly DIAS_COMPLETOS = ['Domingo', 'Segunda-Feira', 'Terça-Feira', 'Quarta-Feira',
    'Quinta-Feira', 'Sexta-Feira', 'Sábado'];

  public static readonly DIAS_INICIAL = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];

  public static getNomeDia(date) {
    return DataUtil.DIAS_COMPLETOS[date.getDay()];
  }

  public static getSiglaDia(date) {
    return DataUtil.DIAS_INICIAL[date.getDay()];
  }

  public static getNomeMes(date) {
    return DataUtil.MESES[date.getMonth()];
  }

  public static isHorarioMaior(horario1: string, horario2: string) {
    const data1 = new Date();
    let hora = horario1.split(':')[0];
    let minutos = horario1.split(':')[1];
    data1.setHours(+hora);
    data1.setMinutes(+minutos);
    const data2 = new Date();
    hora = horario2.split(':')[0];
    minutos = horario2.split(':')[1];
    data2.setHours(+hora);
    data2.setMinutes(+minutos);
    return DataUtil.isDataMaior(data1, data2);

  }

  public static isDataMaior(date1: Date, date2: Date) {
    return date1.getTime() > date2.getTime();
  }

  public static converterDataComHoraEmString(date: Date) {
    if (date.toLocaleDateString) {
      const dia = date.getDate() > 9 ? date.getDate() : '0' + date.getDate();
      const mes = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1);
        return `${date.getFullYear()}-${mes}-${dia} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
    } else {
      return date;
    }
  }

  public static converterDataEmString(date: Date) {
    if (!date.toLocaleDateString) {
      date = new Date(date);
    }

    const dia = date.getDate() > 9 ? date.getDate() : '0' + date.getDate();
    const mes = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1);
    return `${date.getFullYear()}-${mes}-${dia}`;
  }

  public static criarDataHora(horaMinuto: string) {
    let dataHora = new Date();
    dataHora.setHours(parseInt(horaMinuto.split(':')[0]), parseInt(horaMinuto.split(':')[1]));
    return dataHora;
  }

  public static criarDataHoraComoString(dataHora: Date) {
    return dataHora.toLocaleTimeString().substr(0, 5);
  }

  public static getDate(date: string) {
    return new Date(date.replace(/-/g, "/"));
  }

}



// WEBPACK FOOTER //
// ./src/app/util/data.ts